<template>
  <v-layout row justify-center>
    <v-dialog persistent v-model="dialogData" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ clickedCard.title }}</v-card-title>
        <v-card-text>{{ clickedCard.content }}</v-card-text>
        <v-card-text v-if="clickedCard.interval">
          <i>{{ clickedCard.interval }}</i>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!clickedCard.read_at"
            color="green darken-1"
            flat="flat"
            @click="handleDialogMarkAsRead"
          >
            {{ $t("lang.notification.markAsRead") }}
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="handleDialogCancel">
            {{ $t("lang.notification.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "NotificationDialog",
  props: ["card", "dialog"],
  data() {
    return {};
  },
  computed: {
    clickedCard() {
      return this.card;
    },
    dialogData() {
      return this.dialog;
    }
  },
  // mounted() {
  //   this.dialogLoaded = true;
  // },
  methods: {
    handleDialogMarkAsRead() {
      this.clickedCard.read_at = new Date();
      this.clickedCard.interval = 0;
      this.clickedCard.read = true;
      this.$emit("cardMarkRead", this.clickedCard);
      this.$root.$emit("gruTableSearch");
    },
    handleDialogCancel() {
      this.$emit("cardMarkCancel");
    }
  }
};
</script>

<style scoped></style>
